import { render, staticRenderFns } from "./WarningDark.vue?vue&type=template&id=23f9e080&scoped=true&"
import script from "./WarningDark.vue?vue&type=script&lang=js&"
export * from "./WarningDark.vue?vue&type=script&lang=js&"
import style0 from "./WarningDark.vue?vue&type=style&index=0&id=23f9e080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9e080",
  null
  
)

export default component.exports